module.exports = "/_next/static/images/Rabbit-229e264c2e681033bb65c311df34af25.svg";